import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CodeIcon from '@mui/icons-material/Code'

import { BookListStyle } from '../styles'
import CodeNotebookModal from '../modals/CodeNotebookModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const CodeNotebookList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <ResourceDescription
                description={props.description}
                containerSx={BookListStyle.titleContainer}
                typographyProps={{ ...BookListStyle.description, gutterBottom: true }}
            />
            <Box sx={BookListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>By:</span> {props.authors}
                </Typography>
            </Box>
            <Box sx={BookListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>Language:</span> {props.language_name}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={CodeIcon}
            listStyle={BookListStyle}
            modal={<CodeNotebookModal {...props} />}
            title={props.title}
            date={props.pub_date}
            dateLabel='Updated:'
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            buttonText='View Notebook'
            secondaryContent={secondary}
        />
    )
}

export default CodeNotebookList
